<template>
  <v-dialog persistent max-width="80%">
    <v-card class="pa-4">
      <v-card-title class="d-flex justify-space-between align-center">
        New Inventory Item
        <v-spacer></v-spacer>
        <v-btn
          variant="text"
          icon="mdi-close"
          @click="() => $emit('update:modelValue', false)"
          class="close-button"
        />
      </v-card-title>

      <v-card-text class="pa-0 ma-0">
        <AdPlacementCreationStepper
          :created="createdPlacement"
          ref="stepper"
          @submit="$emit('create', $event)"
        />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
  
  <script>
import AdPlacementCreationStepper from "./AdPlacementCreationStepper.vue";
export default {
  name: "InventoryItemCreateDialog",
  components: {
    AdPlacementCreationStepper,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["update:modelValue", "create"],
  data() {
    return {
      createdPlacement: null,
    };
  },
  computed: {},

  watch: {},

  created() {
    console.log("Dialog created");
  },
  methods: {
    setPlacement(placement) {
      this.createdPlacement = placement;
    },
  },
};
</script>